import React from 'react';

import type { TripStatus } from 'generated/graphql';

interface StatusBadgeProps {
  status: TripStatus;
  className?: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  className = '',
}) => {
  const getStatusConfig = () => {
    switch (status) {
      // Self-booking statuses
      case 'IN_HOUSE':
        return { color: 'bg-accentGreen text-white', label: 'IN-HOUSE' };
      case 'UPCOMING':
        return { color: 'bg-blue-100 text-blue-800', label: 'UPCOMING' };
      case 'PENDING':
        return { color: 'bg-yellow-100 text-yellow-800', label: 'PENDING' };
      case 'PAST':
        return { color: 'bg-gray-100 text-gray-600', label: 'PAST' };

      // Group request statuses
      case 'REQUEST_RECEIVED':
        return { color: 'bg-yellow-100 text-yellow-800', label: 'RECEIVED' };
      case 'IN_PROGRESS':
        return { color: 'bg-blue-100 text-blue-800', label: 'IN PROGRESS' };
      case 'MORE_INFO_REQUIRED':
        return {
          color: 'bg-orange-100 text-orange-800',
          label: 'MORE INFO REQUIRED',
        };
      case 'AWAITING_CONFIRMATION':
        return {
          color: 'bg-purple-100 text-purple-800',
          label: 'AWAITING CONFIRMATION',
        };
      case 'CONFIRMED':
        return { color: 'bg-green-100 text-green-800', label: 'CONFIRMED' };
      case 'CANCELED':
        return { color: 'bg-red-100 text-red-800', label: 'CANCELED' };

      default:
        return {
          color: 'bg-gray-100 text-gray-600',
          label: status.replace('_', ' '),
        };
    }
  };

  const { color, label } = getStatusConfig();

  return (
    <span
      className={`inline-block rounded-full px-2 py-1 text-xs font-medium ${color} ${className}`}
    >
      {label}
    </span>
  );
};

export default StatusBadge;
